import RatingItem from "../../GlobalClassification/RatingItem";

import IconDelete from "../../../../layout/others/icon-x.svg";

export default function AdvancesearchRating({
  searchObject,
  setSearchObject,
  t
}) {
  function onChangeRanting(rating) {
    setSearchObject({ ...searchObject, rating: rating });
  }

  function clearRating() {
    let _searchObject = { ...searchObject };
    _searchObject.rating = 0;

    setSearchObject(_searchObject);
  }

  return (
    <>
      <div>
        <legend className="fontsize-legend">{t("Rating(min.)")}</legend>
        <div className="position-star-rating">
          <RatingItem skill={searchObject} onChange={onChangeRanting} />
        </div>
        {searchObject.rating > 0 && (
          <div className="col">
            <button onClick={clearRating} className="btn-mobile clear-rating">
              <img
                src={IconDelete}
                alt="ico-ppl"
                height="12px"
                width="auto"
                style={{ height: "14px" }}
              />
              <a className="clear-button">{t("Clear")}</a>
            </button>
          </div>
        )}
      </div>
    </>
  );
}
